var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscontent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "0jdqiho2fa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.494118 0 0 0 0 0.141176 0 0 0 0 0.917647 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#0jdqiho2fa)",
    transform: "translate(-419 -609)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M11.966 25.64c-.6-.568-.631-1.52-.07-2.129.56-.608 1.494-.647 2.103-.072 1.61 1.531 3.263.122 3.446-.044.547-.496 1.357-.507 1.915-.06.066.053.128.112.186.178.548.62.496 1.572-.116 2.127-1.32 1.197-4.56 2.75-7.464 0zM40.1 23.495c.548.62.496 1.573-.116 2.128-1.32 1.196-4.56 2.75-7.464 0-.6-.569-.63-1.521-.07-2.13.56-.608 1.495-.647 2.103-.071 1.61 1.53 3.263.121 3.446-.044.547-.497 1.357-.508 1.915-.06.066.052.128.112.186.177zM37.879 39.19c.325.763-.02 1.648-.774 1.978-.753.331-1.627-.02-1.953-.784-1.433-3.353-4.818-5.522-8.627-5.522-3.896 0-7.302 2.166-8.678 5.52-.237.577-.79.927-1.372.927-.19 0-.383-.036-.569-.115-.757-.32-1.116-1.2-.802-1.966 1.838-4.48 6.32-7.374 11.421-7.374 4.995 0 9.451 2.88 11.354 7.336zM42.648 52H9.353C4.375 52 .325 47.9.325 42.858V9.142C.325 4.1 4.375 0 9.353 0h33.295c4.978 0 9.027 4.101 9.027 9.142v33.716C51.676 47.9 47.626 52 42.648 52zM9.353 4.301c-2.636 0-4.78 2.171-4.78 4.84v33.716c0 2.669 2.144 4.84 4.78 4.84h33.295c2.635 0 4.78-2.171 4.78-4.84V9.142c0-2.669-2.145-4.84-4.78-4.84H9.353z",
    transform: "translate(419.5 609)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscontent);
export default __webpack_public_path__ + "static/media/discontent.466b5547de95a1285670a1b09a04ed55.svg";
export { ForwardRef as ReactComponent };